import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { EstatusProcesoEnum, HeaderEnum, ProcesoImportarEnum, RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { ImportarProceso, ImpotacionAnalisis } from "@modelo/SIConvertAnalisis.model";
import { TranslateService } from "@ngx-translate/core";
import {DialogoOpcion} from '@mensaje/Modelo/Dialogo.model';
import {AlertaEnum, DialogoEnum, TipoOpcionEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { SistemaService } from "@servicios/Sistema.Service";
import { Pregunta } from "@modelo/proceso/Pregunta.model";
import { RelacionPreguntaComponent } from "@contenido/AppContent/global/relacionpregunta/relacionPregunta.component";
import { LocationStrategy } from "@angular/common";

@Component({
    selector: 'importarpreguntaForm',
    templateUrl: './importarPreguntas.component.html',
    styleUrls: ['./importarPreguntas.component.scss']
})

export class ImportarPreguntasComponent{
    datoGuardado: boolean = false;
    @Output() cerrarImportacion: EventEmitter<any> = new EventEmitter();

    @ViewChild('preguntaimportar') private relacionpregunta!: RelacionPreguntaComponent;
    
    archivo: any = {Archivo: "", MimeType: "", Nombre: ""};
    
    errorActivo: boolean = false;

    importacion: ImpotacionAnalisis = new ImpotacionAnalisis();
    estatusProceso: ProcesoImportarEnum = ProcesoImportarEnum.Inico;
    pasos: Array<ImportarProceso> = [];

    ProcesoSIConvertEnum = ProcesoImportarEnum;
    EstatusProcesoEnum = EstatusProcesoEnum;

    Preguntas!: Pregunta[];
    PreguntaTemporal!: Pregunta[];

    constructor(private appService: AppService, private location: LocationStrategy, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService){
        this.pasos.push(new ImportarProceso({Titulo: this.translate.instant("Layout.Importacion.Paso1"), Estatus: EstatusProcesoEnum.Pendiente}));
        this.pasos.push(new ImportarProceso({Titulo: this.translate.instant("Layout.Importacion.Paso2"), Estatus: EstatusProcesoEnum.Pendiente}));
        this.pasos.push(new ImportarProceso({Titulo: this.translate.instant("Layout.Importacion.Paso3"), Estatus: EstatusProcesoEnum.Pendiente}));

    }


    ngOnInit(){
        this.archivo = {Archivo: "", MimeType: "", Nombre: ""};
        this.estatusProceso = ProcesoImportarEnum.Inico;
        this.IniciarDatos();
        this.errorActivo = false;
    }

    //Inicia la secuencia de importacion de preguntas
    IniciarDatos() {
        this.importacion = new ImpotacionAnalisis();
        this.pasos[0].Estatus = EstatusProcesoEnum.Pendiente;
        this.pasos[1].Estatus = EstatusProcesoEnum.Pendiente;
        this.pasos[2].Estatus = EstatusProcesoEnum.Pendiente;

        this.pasos[1].Titulo = this.translate.instant("Layout.Importacion.Paso2");
        this.pasos[2].Titulo = this.translate.instant("Layout.Importacion.Paso3");
    }

    //Valida la informacion base eh importante del documento con las preguntas que se van a importar
    ValidarArchivo() {
        this.errorActivo = true;

        if (!this.archivo.Archivo) {
            this.mensajeService.Alerta(AlertaEnum.Warning, 'Seleccione un archivo valido');
            return;
        }

        this.IniciarDatos();
        this.pasos[0].Estatus = EstatusProcesoEnum.Procesando;

        this.estatusProceso = ProcesoImportarEnum.Procesando;

        this.appService.Post("planeacion/pregunta/layout/validar/file", this.archivo, [HeaderEnum.NoShowLoading]).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {

                var analisis = res.data;

                if (!analisis.Finalizado) {
                    this.estatusProceso = ProcesoImportarEnum.Error;
                    this.pasos[0].Estatus = EstatusProcesoEnum.Error;
                }
                else {
                    this.estatusProceso = ProcesoImportarEnum.Validado;
                    this.pasos[0].Estatus = EstatusProcesoEnum.Success;

                    this.importacion.Registros = analisis.Registros;
                    this.Preguntas = [];
                    this.ValidarDatosRow();
                }

                this.importacion.Errores = analisis.Errores;
            }
            else {
                this.estatusProceso = ProcesoImportarEnum.Error;
                this.pasos[0].Estatus = EstatusProcesoEnum.Error;
            }
        }).catch(err => {
            this.estatusProceso = ProcesoImportarEnum.Inico;
            this.pasos[0].Estatus = EstatusProcesoEnum.Pendiente;
        })
    }

    //Descarga un layout vacio
    DescargarLayout() {
        this.appService.PostGetFile("planeacion/pregunta/layout", {})
    }

    //Valida cada fila del documento para que cumpla con la informacion correspondiente para su importacion
    ValidarDatosRow() {
        this.pasos[1].Estatus = EstatusProcesoEnum.Procesando;
        this.pasos[1].Titulo = this.translate.instant("Layout.Importacion.Paso2") + " " + this.importacion.Renglon + " " + this.translate.instant("Layout.Importacion.De") + " " + this.importacion.Registros + " (" + this.sistemaService.Calcularporcentage(this.importacion.Renglon, this.importacion.Registros) + "%)";

        this.appService.Post("planeacion/pregunta/layout/validar/renglon/" + this.importacion.Renglon, this.archivo, [HeaderEnum.NoShowLoading]).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                let respuesta = res.data;

                this.importacion.Renglon += 1;

                this.importacion.Correctos += respuesta.Correctos;
                this.importacion.Incorrectos += respuesta.Incorrectos;
                this.importacion.Omitidos += respuesta.Omitidos;

                this.importacion.Errores = this.importacion.Errores.concat(respuesta.Errores);
                this.importacion.Advertencias = this.importacion.Advertencias.concat(respuesta.Advertencias);

                if (respuesta.Entidad && !respuesta.Omitidos) {
                    let preguntas = new Pregunta(respuesta.Entidad);
                    this.Preguntas.push(preguntas)
                }

                if (this.importacion.Renglon >= this.importacion.Registros) {
                    if (this.importacion.Errores.length > 0) {
                        this.estatusProceso = ProcesoImportarEnum.Error;
                        this.pasos[1].Estatus = EstatusProcesoEnum.Error;
                    }
                    else {
                        this.estatusProceso = ProcesoImportarEnum.EnEspera;
                        this.pasos[1].Estatus = EstatusProcesoEnum.Success;

                        this.importacion.Errores = this.importacion.Advertencias;
                    }

                    this.pasos[1].Titulo = this.translate.instant("Layout.Importacion.Paso2") + ". " + this.translate.instant("Layout.Importacion.Completado");
                }
                else {
                    this.ValidarDatosRow();
                }
            }
            else {
                this.estatusProceso = ProcesoImportarEnum.Error;
                this.pasos[1].Estatus = EstatusProcesoEnum.Error;
            }
        }).catch(err => {
            this.estatusProceso = ProcesoImportarEnum.Error;
            this.pasos[1].Estatus = EstatusProcesoEnum.Error;
        })
    }

    //Importa la informacion que ya fue validada y aprobada
    ImportarDatos(indexInicio: number) {
        let contador = 0;
        this.estatusProceso = ProcesoImportarEnum.Expotando;
        this.pasos[2].Estatus = EstatusProcesoEnum.Procesando;
        this.pasos[2].Titulo = this.translate.instant("Layout.Importacion.Paso3") + " " + this.importacion.Importados + " " + this.translate.instant("Layout.Importacion.De") + " " + (this.importacion.Registros - this.importacion.Omitidos) + " (" + this.sistemaService.Calcularporcentage(this.importacion.Importados, this.importacion.Registros - this.importacion.Omitidos) + "%)";


        this.PreguntaTemporal = this.Preguntas;
        let index = 0;
        let list:any[] = [];
        while(index < this.PreguntaTemporal.length){
            let element = this.PreguntaTemporal[index]
            if(index == 0){
                index+=1;
            }else{
                let elementant = this.PreguntaTemporal[index - 1];
                if(element.competenciaid == elementant.competenciaid && element.criterioid == elementant.criterioid && element.escalaevaluacionid == elementant.escalaevaluacionid && element.pregunta == elementant.pregunta && element.tipopreguntaid == elementant.tipopreguntaid && element.relacionado == elementant.relacionado){
                    if(element.nivelid != elementant.nivelid){
                        if(elementant.nivelid[0] == 0){
                            this.PreguntaTemporal.splice(index,1);
                            contador += 1;
                            index = 0;
                        }
                        else if(element.nivelid[0] == 0){
                            this.PreguntaTemporal.splice(index,1);
                            contador += 1;
                            index = 0;
                        }
                        else{
                            if(element.nivelid[0] != elementant.nivelid[0]){
                                elementant.nivelid.push(element.nivelid[0]);
                            }
                            this.PreguntaTemporal.splice(index,1);

                            contador += 1;
                            index-=1;
                        }
                    }
                }else{
                    index+=1;
                }
            }
        }

        this.Preguntas = this.PreguntaTemporal;

        if(this.Preguntas[indexInicio]){
            if(this.Preguntas[indexInicio].nivelid[0] == 0){
                this.Preguntas[indexInicio].nivelid = [];
            }
            this.appService.Post("planeacion/pregunta", this.Preguntas[indexInicio], [HeaderEnum.NoShowLoading]).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    if(contador > 0){
                        this.importacion.Importados = contador;
                    }
                    this.importacion.Importados += 1;
                    this.Terminar(indexInicio + 1);
                }
                else {
                    this.estatusProceso = ProcesoImportarEnum.Error;
                    this.pasos[2].Estatus = EstatusProcesoEnum.Error;
                }
            }).catch(err => {
                if (err.status == RespuestaEstatusEnum.Parcial) {
                    this.importacion.Omitidos += 1;
                    this.Terminar(indexInicio + 1);
                } else {
                    this.estatusProceso = ProcesoImportarEnum.Error;
                    this.pasos[2].Estatus = EstatusProcesoEnum.Error;
                }
            })
        }else{
            this.Terminar(indexInicio + 1);
        }
    }

    //Termina la secuencia de importacion de preguntas
    Terminar(indexInicio: number) {
        if (indexInicio >= this.importacion.Registros) {
            this.estatusProceso = ProcesoImportarEnum.Finalizado;
            this.pasos[2].Estatus = EstatusProcesoEnum.Success;

            this.pasos[2].Titulo = this.translate.instant("Layout.Importacion.Paso3") + ". " + this.translate.instant("Layout.Importacion.Completado");
            this.datoGuardado = true;
        }
        else {
            this.ImportarDatos(indexInicio);
        }
    }

    //Manda una modal para seleccionar las preguntas que se quieren exportar en el layout
    AgregarPreguntasLayout() {
        this.relacionpregunta.Modal();
    }

    //Exporta el layout con la lista de preguntas seleccionadas
    ExportarLayoutConDatos(listpreguntas: any){
        if(listpreguntas){
            this.appService.PostGetFile("planeacion/pregunta/layout", listpreguntas).then(res =>{
                if(res.status == RespuestaEstatusEnum.Success){
                    this.relacionpregunta.CerrarModal()
                }
            })
        }
    }

    //Cierra toda la pantalla de importar preguntas
    Salir() {
        let opciones = [];

        opciones.push(new DialogoOpcion({Titulo: this.translate.instant("Salir"), Valor: 1}));
        opciones.push(new DialogoOpcion({Titulo: this.translate.instant("Cancelar"), Valor: 2, Tipo: TipoOpcionEnum.negativo}));

        this.mensajeService.Dialogo(DialogoEnum.normal, "", this.translate.instant("MensajeSalir"), opciones).then((respuesta: number) => {
            if (respuesta == 1) {
                this.CerrarModal();
            }
        });
    }

    //Cierra la modal de seleccion de preugntas para exportar
    CerrarModal() {
        this.cerrarImportacion.emit(this.datoGuardado);
    }
}